//telas externas
//import inicio from '../pages/inicio.vue'

import home from '../pages/home.vue'
import listaPedidos from '../components/ListaPedidos.vue'
import listaExames from '../components/ListaPedidoExames.vue'

//Telas de erro
import pagina403 from '../pages/erros/403.vue'
import pagina404 from '../pages/erros/404.vue'


const routes = [
    {
        name: 'home',
        path: '/',
        component: home,
    },
    { 
        path: '/lista-pedidos', 
        name: 'lista-pedidos', 
        component: listaPedidos,
        props: true,
    },
    { 
        path: '/lista-exames', 
        name: 'lista-exames', 
        component: listaExames 
    },
    {
        name: '403',
        path: '/403',
        component: pagina403,
    },
    //tela "não encontrada"
    {
        path: '*',
        name: '/404',
        component: pagina404,
    }
];

export default routes;